<template>
  <template v-if="promoCode && !isExcluded">
    <LayoutPromoCodePill
      v-if="minimized"
      :label="promoCode.pillLabel"
      :raised="isProductPage"
      @expand="minimized = false"
    />
    <LayoutPromoCodeModal
      v-else-if="useModal"
      :promo-code="promoCode"
      @minimize="minimized = true"
    />
    <LayoutPromoCodeBanner
      v-else
      :promo-code="promoCode"
      @minimize="minimized = true"
    />
  </template>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";

const route = useRoute();
const config = useRuntimeConfig();
const features: any = config.public.features;
const promoCode = features?.promoCode;

const isExcluded = computed(() =>
  !!(
    promoCode?.excludeProductSlugs &&
    route.params.productSlug &&
    promoCode.excludeProductSlugs.includes(route.params.productSlug as string)
  )
);

// present on every product-detail route (both the `/experiences/[productSlug]` and
// `/things-to-do-in-[slug]/[productSlug]` trees share this param name) and on cart
const isProductPage = useIsProductPage();
const isCartPage = computed(() => route.name?.toString().startsWith("cart"));
const useModal = computed(() => isProductPage.value || isCartPage.value);

// open by default everywhere (banner or modal); user can minimize it manually.
// entering a product page always forces it back open, even if it was closed elsewhere.
const minimized = ref(false);
watch(isProductPage, (onProductPage) => {
  if (onProductPage) minimized.value = false;
});
</script>
